export default __webpack_public_path__ + "static/media/icon-search.738df29a.svg";